import { render, staticRenderFns } from "./HJ0096.vue?vue&type=template&id=38d4867d&scoped=true&"
import script from "./HJ0096.vue?vue&type=script&lang=js&"
export * from "./HJ0096.vue?vue&type=script&lang=js&"
import style0 from "./HJ0096.vue?vue&type=style&index=0&id=38d4867d&prod&lang=less&scoped=true&"
import style1 from "./HJ0096.vue?vue&type=style&index=1&id=38d4867d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4867d",
  null
  
)

export default component.exports